import { styled, TypographyProps } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import {
  Box,
  ButtonsContainer,
  Modal,
  useModalContext,
  Button,
  Typography,
} from '@app-velocity/ui';

import { SavePluginImage } from './SavePluginImage';

const StyledDescription = styled(Box)({
  textAlign: 'left',
});

const StyledTitle = styled(Typography)<
  TypographyProps & { component: React.ElementType }
>(({ theme }) => ({
  fontSize: 18,
}));

const ImageContainer = styled('div')({
  svg: {
    maxWidth: '100%',
    width: '100%',
    objectFit: 'contain',
  },
});

export const SavePluginModalContent = () => {
  const { closeModal } = useModalContext();
  const { t } = useI18n();

  const navigateToPluginPage = () => {
    // to get rid of -develop
    const pluginId = import.meta.env.VITE_FIGMA_PLUGIN_ID.split('-')[0];
    const url = `https://www.figma.com/community/plugin/${pluginId}`;
    window.open(url);
    closeModal();
  };

  return (
    <Modal data-testid="save-plugin-modal">
      <Modal.Content>
        <ImageContainer>
          <SavePluginImage />
        </ImageContainer>
        <StyledDescription>
          <StyledTitle variant="header" component="h2">
            {t('shared:save_plugin.title')}
          </StyledTitle>
        </StyledDescription>
        <ButtonsContainer direction="vertical">
          <Button
            variant="contained"
            color="primary"
            onClick={navigateToPluginPage}
          >
            {t('shared:save_plugin.save')}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              closeModal();
            }}
          >
            {t('shared:save_plugin.close')}
          </Button>
        </ButtonsContainer>
      </Modal.Content>
    </Modal>
  );
};
